<app-label-configuration
  [title]="'P00058.installation.pompe.speeeds' | translate"
  [titleListe]="'P00058.installation.pompe.speed1' | translate"
  [value]="actionStack!.getValue('pvPVitesseV1')"
  [liste]="getSpeedEnum(35, 100)"
  [description]="'P00058.installation.pompe.speed1.description' | translate"
  (onPress)="onSpeed1Change($event)"
>
</app-label-configuration>

<app-label-configuration
  [titleListe]="'P00058.installation.pompe.speed2' | translate"
  [value]="actionStack!.getValue('pvPVitesseV2')"
  [liste]="getSpeedEnum(35, 100)"
  [description]="'P00058.installation.pompe.speed2.description' | translate"
  (onPress)="onSpeed2Change($event)"
>
</app-label-configuration>

<app-label-configuration
  [titleListe]="'P00058.installation.pompe.speedMAX' | translate"
  [value]="actionStack!.getValue('pvPVitesseV3')"
  [liste]="getSpeedEnum(35, 100)"
  [description]="'P00058.installation.pompe.speedMAX.description' | translate"
  (onPress)="onSpeed3Change($event)"
>
</app-label-configuration>

<app-label-configuration
  [title]="'P00058.installation.filtration.programmeTitre' | translate"
  [information]="openEnSavoirPlus"
  [titleListe]="'P00058.installation.filtration.programme' | translate"
  [description]="
    'P00058.installation.filtration.programmeDescription' | translate
  "
  [value]="actionStack!.getValue('pvCProgrammeAuto')"
  [liste]="P00058ProgrammeFiltrationAuto"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Controle,
      'pvCProgrammeAuto',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

@if (actionStack!.getValue('pvCProgrammeAuto') === 1) {
  <app-two-choices-control
    [title]="'P00058.programme.horlogeHiver' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('pvPTypeHorlogeHiver')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPTypeHorlogeHiver',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('pvPTypeHorlogeHiver') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="'P00058.filtration.reglage.descriptionHorloge' | translate"
  ></app-label-description>
}

@if (actionStack!.getValue('pvCProgrammeAuto') === 0) {
  <app-two-choices-control
    [title]="'P00058.programme.horlogeEte' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('pvPTypeHorlogeEte')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPTypeHorlogeEte',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('pvPTypeHorlogeEte') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockPEEScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="
      'P00058.filtration.reglage.descriptionEteHorloge' | translate
    "
  ></app-label-description>
}

@if (actionStack!.getValue('pvCProgrammeAuto') === 3) {
  <app-label-configuration
    [title]="'P00058.installation.bathing' | translate"
    [titleListe]="'P00058.installation.bathing.timer' | translate"
    [value]="actionStack!.getValue('pvPDureeBaignade')"
    [information]="openEnSavoirPlus2"
    [liste]="getBathingTimer()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPDureeBaignade',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-configuration
  [title]="'P00058.installation.ecremage' | translate"
  [information]="getEnSavoirPlus"
  [titleListe]="'P00058.installation.ecremage.timer' | translate"
  [value]="actionStack!.getValue('pvPDureeEcremage')"
  [liste]="getEcremageTimerEnum()"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPDureeEcremage',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-configuration
  [titleListe]="'P00058.installation.ecremage.speed' | translate"
  [value]="actionStack!.getValue('pvPVitesseEcremage')"
  [liste]="getSpeedEnum(70, 100)"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseEcremage',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="'P00058.installation.amorcage.title' | translate"
  [nameCustom]="'P00058.installation.amorcage.smallTitle' | translate"
  [value]="actionStack!.getValue('pvIActivationAmorcage') !== 0"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvIActivationAmorcage',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

@if (actionStack!.getValue('pvIActivationAmorcage') === 1) {
  <app-label-configuration
    [titleListe]="'P00058.installation.armocagetime' | translate"
    [value]="actionStack!.getValue('pvPDureeAmorcage')"
    [liste]="getAmorcageTimerEnum()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPDureeAmorcage',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>

  <app-label-configuration
    [titleListe]="'P00058.installation.armocagespeed' | translate"
    [value]="actionStack!.getValue('pvPVitesseAmorcage')"
    [liste]="getSpeedEnum(35, 100)"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPVitesseAmorcage',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-description
  [description]="'P00058.installation.amorcage.description' | translate"
></app-label-description>

<app-switch-configuration
  [title]="'P00058.installation.proliferation.filtration2424.title' | translate"
  [nameCustom]="
    'P00058.installation.proliferation.filtration2424.smallTitle' | translate
  "
  [value]="actionStack!.getValue('pvPActivationFonction24') !== 0"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPActivationFonction24',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

@if (actionStack!.getValue('pvPActivationFonction24') === 1) {
  <app-label-configuration
    [titleListe]="
      'P00058.installation.proliferation.filtration2424.seuil.title' | translate
    "
    [value]="actionStack!.getValue('pvPSeuilTemperature24')"
    [liste]="P00058SeuilTemperatureFiltration2424()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPSeuilTemperature24',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-description
  [description]="
    'P00058.installation.proliferation.filtration2424.description' | translate
  "
></app-label-description>

<div class="my-2">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00058.installation.preventiongel.typeFonctionHorsGel.title'
          | translate
      }}</ion-label>
    </div>
  </div>
</div>

@if (hasProduitP00032() > 0 && hasProduitP00030() > 0) {
  <app-label-configuration
    [titleListe]="
      'P00058.installation.prevention.capteurTemperatureReferenceHorsGel.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('pvISourceTemperatureHorsGel')"
    [liste]="P00058CapteurTemperatureEnum"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Installation,
        'pvISourceTemperatureHorsGel',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-configuration
  [titleListe]="
    'P00058.installation.prevention.seuilTemperatureReferenceHorsGel.smallTitle'
      | translate
  "
  [value]="actionStack!.getValue('pvPSeuilTemperatureHorsGel')"
  [liste]="P00058SeuilTemperatureHorsGel()"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPSeuilTemperatureHorsGel',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-label-description
  [description]="
    'P00058.installation.preventiongel.typeFonctionHorsGel.description'
      | translate
  "
></app-label-description>
